import React, { useState } from 'react';
import classNames from 'classnames';
import Dropdown from './Dropdown';

const styles = require('./SelectWithTags.module.scss');

type dropDownOption = {
  value: string;
  label: string;
};

interface Props {
  label: string;
  subLabel?: string;
  placeholder?: string;
  isRequired: boolean;
  data: string[];
  selectedData?: string[];
  inputId: string;
  inputName: string;
  officeLocationsSelector?: string;
  countryNames?: Record<string, string>;
}

const transformData = (data: string[]): dropDownOption[] =>
  data.map(d => ({ value: d.toLowerCase(), label: d }));

const SelectWithTags = (props: Props) => {
  const {
    label,
    subLabel,
    placeholder,
    data,
    selectedData,
    isRequired,
    inputId,
    inputName,
    officeLocationsSelector,
    countryNames,
  } = props;
  // Drop blank entries so a persisted sentinel value ([""]) never seeds a ghost tag
  // in the display or re-submits itself through the hidden inputs (ILJ-1392).
  const cleanedSelectedData = (selectedData ?? []).filter(Boolean);
  const [currentData, setCurrentData] = useState<dropDownOption[]>(
    transformData(cleanedSelectedData)
  );
  const isArrayParam = inputName.endsWith('[]');

  return (
    <>
      <div className={styles.searchHeader}>
        <div className={styles.labelContainer}>
          <label className={classNames(styles.label, 'ld-form-label')}>{label}</label>
          {isRequired && <span className={classNames(styles.required, 'ld-form-required')}>*</span>}
          <p className={classNames(styles.subLabel)}>{subLabel}</p>
        </div>
      </div>
      <Dropdown
        placeHolder={placeholder ?? 'Select'}
        options={transformData(data)}
        selectedData={transformData(cleanedSelectedData)}
        onChange={setCurrentData}
        officeLocationsSelector={officeLocationsSelector}
        countryNames={countryNames}
      />
      {isArrayParam ? (
        // Rails array param convention: a blank sentinel input keeps the param key present
        // (and clears the array) when nothing is selected, plus one plain input per tag.
        // A single JSON-encoded value here would submit the literal string "[]" as an array
        // element instead of an empty array (ILJ-814).
        <>
          <input type='hidden' id={inputId} name={inputName} value='' />
          {currentData.map(option => (
            <input key={option.value} type='hidden' name={inputName} value={option.label} />
          ))}
        </>
      ) : (
        // Non-array param names (e.g. job_ad_form[top_geographies]) are consumed via
        // JSON.parse on the backend, so submit a single JSON-encoded value instead.
        <input
          type='hidden'
          id={inputId}
          name={inputName}
          value={JSON.stringify(currentData.map(option => option.label))}
        />
      )}
    </>
  );
};

export default SelectWithTags;
